import { makeAutoObservable } from "mobx";
import { RSet } from "../../collections";
import { Tristate } from "../../core";
export class PreorderAvailability {
    constructor(params) {
        this.reasons = [];
        this.scope = params.scope;
        this.productTypes = params.productTypes;
        makeAutoObservable(this);
    }
    get unavailabilityReasons() {
        return this.isAvailable.isDefinitelyTrue
            ? RSet.empty()
            : RSet.singleton("Preorder");
    }
    get isAvailable() {
        var _a, _b;
        const now = (_b = (_a = this.scope.currentFulfillmentTimes) === null || _a === void 0 ? void 0 : _a.now) !== null && _b !== void 0 ? _b : null;
        const preorderTime = this.scope.preorderTime;
        console.log("Preorder availability", now === null || now === void 0 ? void 0 : now.toString, preorderTime === null || preorderTime === void 0 ? void 0 : preorderTime.toString);
        if (!now || !preorderTime) {
            return Tristate.True;
        }
        if (this.productTypes.every((productType) => productType.preorderSettings.some((preorderSettings) => {
            const dateRange = preorderSettings.dateRange(now);
            console.log();
            console.log("isAvailable", {
                now: now.toString,
                dateRange: dateRange.toString(),
                preorderTime: preorderTime.toString,
                includes: dateRange.includes(preorderTime),
            });
            const result = dateRange.includes(preorderTime);
            this.reasons.push(`${preorderTime.toString} not in date range: ${dateRange.toString()} `);
            return result;
        }))) {
            return Tristate.True;
        }
        return Tristate.False;
    }
    accept(availabilityVisitor) {
        availabilityVisitor.visitPreorder(this);
    }
}
